<form #playlistForm="ngForm" (ngSubmit)="save()" novalidate>
    <div class="modal-header">
      <h5 class="modal-title">Edit {{playlist}} Playlist</h5>
      <button type="button" class="btn-close btn" (click)="close()">
        <i class="fa fa-close"></i>
      </button>
    </div>
  
    <div class="modal-body">
      <div class="mb-3">
        <label>Playlist Name</label>
        <input
          [(ngModel)]="playlistData.name"
          name="name"
          class="form-control"
          required
          #name="ngModel"
        />
        <div *ngIf="name.invalid && name.touched" class="text-danger">
          Playlist Name is required.
        </div>
      </div>
  
      <div class="mb-3" *ngIf="playlistData.type == 1 || playlistData.type == 3 || playlistData.type == 4 ">
        <label>Username</label>
        <input
          [(ngModel)]="playlistData.username"
          name="username"
          class="form-control"
          required
          #username="ngModel"
        />
        <div *ngIf="username.invalid && username.touched" class="text-danger">
          Username is required.
        </div>
      </div>
  
      <div class="mb-3" *ngIf="playlistData.type == 1 || playlistData.type == 3 || playlistData.type == 4 ">
        <label>Password</label>
        <input
          [(ngModel)]="playlistData.pwd"
          name="pwd"
          class="form-control"
          required
          #pwd="ngModel"
        />
        <div *ngIf="pwd.invalid && pwd.touched" class="text-danger">
          Password is required.
        </div>
      </div>
  
      <div class="mb-3"  *ngIf="playlistData.type == 1 || playlistData.type == 2 || playlistData.type == 3 || playlistData.type == 4 " >
        <label>URL</label>
        <input
          [(ngModel)]="playlistData.url"
          name="url"
          class="form-control"
          required
          #url="ngModel"
        />
        <div *ngIf="url.invalid && url.touched" class="text-danger">
          URL is required.
        </div>
        <div class="text-danger mb-2" *ngIf="errorMessage">{{ errorMessage }}</div>

      </div>
    </div>
  
    <div class="modal-footer">
      <button class="btn btn-secondary" type="button" (click)="close()">Cancel</button>
      <button class="btn btn-primary" type="submit" [disabled]="playlistForm.invalid">
        Save
      </button>
    </div>
  </form>
  